import React from "react";
import { Chip, Stack, Typography } from "@mui/material";

const Item = ({ label, children }) => (
  <Stack spacing={0.25} sx={{ minWidth: 160 }}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={600}>
      {children}
    </Typography>
  </Stack>
);

// The page header: what this run is, and what it compares.
const RunLabels = ({ goldenSetName, goldenSetVersion, scripts, production, test }) => (
  <Stack spacing={1.5}>
    <Chip
      label="Golden set run (internal evaluation)"
      color="primary"
      variant="outlined"
      size="small"
      sx={{ alignSelf: "flex-start" }}
    />
    <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 1.5, md: 4 }} flexWrap="wrap" useFlexGap>
      <Item label="Golden set">
        {goldenSetName || "not recorded"} · version {goldenSetVersion || "not recorded"}
      </Item>
      <Item label={scripts.length === 1 ? "Script" : `Scripts (${scripts.length})`}>
        {scripts.length ? scripts.join(", ") : "not recorded"}
      </Item>
      <Item label="Production engine version">{production || "not recorded"}</Item>
      <Item label="Test engine version">{test || "This run has no test engine version"}</Item>
    </Stack>
  </Stack>
);

export default RunLabels;
